export const skills = [
  {
    fontName: 'html5',
    title: 'HTML-5',
  },
  {
    fontName: 'css3-alt',
    title: 'CSS-3',
  },
  {
    fontName: 'js',
    title: 'Javascript',
  },
  {
    fontName: 'php',
    title: 'Php',
  },
  {
    fontName: 'java',
    title: 'Java',
  },
  {
    fontName: 'python',
    title: 'Python',
  },
  {
    fontName: 'sass',
    title: 'Sass',
  },
  {
    fontName: 'aws',
    title: 'Aws',
  },
  {
    fontName: 'hotjar',
    title: 'Firebase',
  },
  {
    fontName: 'git',
    title: 'Git',
  },
  {
    fontName: 'react',
    title: 'React native',
  },
  {
    fontName: 'npm',
    title: 'Npm',
  },
];
